/**
 * 智能体分类枚举
 */
export enum AgentType {
  /** 写作类 */
  WRITING = 1,
  /** 创作大师 */
  CREATIVE_MASTER = 2,
  /** 效率神器 */
  EFFICIENCY_TOOL = 3,
  /** 创意满分 */
  CREATIVE_FULL = 4,
}

/**
 * AgentRes，智能体
 */
export interface AgentRes {
  /** 智能体id */
  agentId?: number
  /** 智能体属性 0私有智能体 1公共智能体 */
  attribute?: number
  /** 创建时间 */
  createTime?: number
  /** 创建人 */
  creator?: string
  /** 授权的部门id列表 */
  departmentIdList?: number[]
  /** 简介 */
  description?: string
  /** 开场白 */
  greeting?: string
  /** 图标 */
  icon?: string
  /** 自增id */
  id?: string
  /** 是否发版 0未发版 1发版 */
  isPublish?: number
  /** 是否编辑过 0否 1是 */
  isUpdated?: number
  /** 知识库列表 */
  knowledgeBaseIdList?: string[]
  /** 模型id，0：通义千问 */
  modelId?: number
  modelSettingVo?: ModelSetting
  /** 名称 */
  name?: string
  /** 提问灵感列表 */
  questionSuggestionList?: string[]
  /** 设定 */
  setting?: string
  /** 技能列表：文生图 1，网页搜索 2，代码执行器 3； */
  skillTypeList?: number[]
  /** 智能体分类 */
  type?: AgentType
  /** 修改人 */
  updater?: string
  /** 修改时间 */
  updateTime?: number
  /** 创建人用户id */
  userId?: string
  /** 版本：版本号，0为草稿 */
  version?: string
  /** 工作空间id */
  workspaceId?: number
  /** 工作空间名称 */
  workspaceName?: string
  /** 创建人电话 */
  phone?: string
}

/**
 * ModelSetting，模型设置参数
 */
export interface ModelSetting {
  /** 最大回复长度 */
  maxReplyTokens?: number
  /** 携带上下午数 */
  roundsContext?: number
  /** 生成的随机性 */
  temperature?: number
}

/**
 * 基础智能体请求参数
 */
export interface BaseAgentRequest {
  /** 简介 */
  description?: string
  /** 开场白 */
  greeting?: string
  /** 图标 */
  icon?: string
  /** 是否发版 0未发版/草稿 1发版 */
  isPublish?: number
  /** 知识库列表 */
  knowledgeBaseIds?: string[]
  /** 模型id，0：通义千问 */
  modelId?: number
  /** 模型设置参数 */
  modelSetting?: ModelSetting
  /** 名称 */
  name?: string
  /** 提问灵感列表 */
  questionSuggestions?: string[]
  /** 设定 */
  setting?: string
  /** 技能列表：文生图 1，网页搜索 2，代码执行器 3； */
  skillType?: number[]
  /** 智能体分类 */
  type?: AgentType
  /** 创建人用户id */
  userId?: string
  /** 版本：版本号 */
  version?: string
  /** 工作空间id */
  workspaceId: string
}

/**
 * 编辑智能体请求参数
 */
export interface UpdateAgentRequest extends BaseAgentRequest {
  /** 智能体id（编辑时必填） */
  id: string
}

/**
 * @deprecated 使用 BaseAgentRequest 或 UpdateAgentRequest 替代
 * 保持向后兼容的旧接口
 */
export interface AgentRequest extends BaseAgentRequest {
  /** 智能体id（编辑时使用） */
  id?: string
}

/**
 * 搜索智能体请求参数
 */
export interface SearchAgentRequest {
  /** 搜索关键词 */
  keyWord?: string
  /** 工作空间id */
  workspaceId?: string
}

/**
 * 智能体列表响应
 */
export type AgentListResponse = AgentRes[]

/**
 * 根据ID查询智能体请求参数
 */
export interface GetAgentByIdRequest {
  /** 智能体ID */
  agentId: string
}

/**
 * 根据AGENT_ID查询草稿智能体请求参数
 */
export interface GetDraftByAgentIdRequest {
  /** AGENT_ID */
  agentId: string
}

/**
 * 智能体详情响应
 */
export interface AgentDetailResponse {
  /** 智能体详情 */
  agent: AgentRes
}

/**
 * 发布智能体请求参数
 */
export interface PublishAgentRequest {
  /** 智能体id */
  agentId: string
  /** 权限部门列表 */
  departmentIdList?: string[]
  /** 自增id */
  id?: string
  /** 版本：版本号，0为草稿 */
  version?: string
  /** 工作空间id */
  workspaceId?: string
}

/**
 * 首页展示智能体请求参数
 */
export interface HomeDisplayAgentRequest {
  /** 搜索关键词 */
  keyWord?: string
  /** 智能体分类 */
  type?: AgentType
  /** 工作空间id */
  workspaceId?: string
}

/**
 * 首页展示智能体响应
 */
export interface HomeDisplayAgentResponse {
  /** 平台精选智能体 */
  platformPicks: AgentRes[]
  /** 热门智能体 */
  topAgents: AgentRes[]
}
